import { render } from "./CreateSupplierInvoiceView.vue?vue&type=template&id=0b017662&scoped=true"
import script from "./CreateSupplierInvoiceView.vue?vue&type=script&lang=js"
export * from "./CreateSupplierInvoiceView.vue?vue&type=script&lang=js"

import "./CreateSupplierInvoiceView.vue?vue&type=style&index=0&id=0b017662&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b017662"]])

export default __exports__